import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { getThemeColors } from '../constants/colors';

const ThemeToggle = ({ isDarkMode, onToggle }) => {
  const theme = getThemeColors(isDarkMode);
  
  return (
    <div className="flex justify-end mb-4">
      <button
        onClick={onToggle}
        className={`
          p-2 rounded-full transition-all duration-200
          ${isDarkMode ? 'bg-gray-700 text-yellow-400' : 'bg-gray-200 text-gray-900'}
          hover:scale-110 transform
          focus:outline-none focus:ring-2 focus:ring-offset-2
          ${isDarkMode ? 'focus:ring-yellow-400' : 'focus:ring-gray-400'}
        `}
        aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {isDarkMode ? (
          <Moon className="w-5 h-5" />
        ) : (
          <Sun className="w-5 h-5" />
        )}
      </button>
    </div>
  );
};

export default ThemeToggle;